<template>
  <div class="aboutpage6">
    <div class="aboutpage6List">
      <div class="item">
        <div class="itemImg">
          <el-image :src="img.icon1" fit="fill"></el-image>
        </div>
        <div class="itemRight">
          <div class="titel">通迅地址</div>
          <div class="text">上海市虹口区高阳路147号405室</div>
        </div>
      </div>
      <div class="item">
        <div class="itemImg">
          <el-image :src="img.icon2" fit="fill"></el-image>
        </div>
        <div class="itemRight">
          <div class="titel">联系电话</div>
          <div class="text">021-65434092</div>
        </div>
      </div>
      <div class="item">
        <div class="itemImg">
          <el-image :src="img.icon4" fit="fill"></el-image>
        </div>
        <div class="itemRight">
          <div class="titel">传真</div>
          <div class="text">021-65967009</div>
        </div>
      </div>
      <div class="item">
        <div class="itemImg">
          <el-image :src="img.icon4" fit="fill"></el-image>
        </div>
        <div class="itemRight">
          <div class="titel">《航海》期刊投稿邮箱</div>
          <div class="text">navigation1978@163.com</div>
        </div>
      </div>
    </div>
    <div class="about-box">
      <div class="box-title">官方公众号</div>
      <div class="box-img">
        <el-image :src="img.code" fit="fill"></el-image>
      </div>
      <div class="box-footer">上海市航海学会</div>
    </div>
    <div class="he50"></div>
    <div class="consulting-title">联系地址</div>
    <div class="consulting-line"></div>
    <div class="consulting-area w-main">
      <div class="areaImg">
        <img src="../../../../assets/img/consulting/abg.png" alt />
      </div>
      <div class="areaBox">
        <img src="../../../../assets/img/consulting/areaBg.png" alt />
        <!-- <div class="p1">咨询服务</div>
        <div class="h1">上海市航海学会学术咨询部</div>
        <div class="p2"><span>联系人：</span>姜朝（副主任）</div>
        <div class="p2">
          <span>业务范畴：</span>海事技术服务、海事诉讼鉴定、<br />通航安全评估
        </div>
        <div class="p2"><span>地址：</span>上海市虹口区高阳路147号405室</div>
        <div class="p2"><span> 电话：</span>021-65434092</div>
        <div class="p2"><span>传真：</span>021-65967009</div>
        <div class="p2"><span>手机：</span>86-13701954872</div>
        <div class="p2"><span>邮箱：</span>navigation1978@163.com</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import icon1 from "@/assets/img/about/page6-icon1.png";
import icon2 from "@/assets/img/about/page6-icon2.png";
import icon3 from "@/assets/img/about/page6-icon3.png";
import icon4 from "@/assets/img/about/page6-icon4.png";
import code from "@/assets/img/home/code.png";

export default {
  data() {
    return {
      img: {
        icon1,
        icon2,
        icon3,
        icon4,
        code
      }
    };
  },
  components: {}
};
</script>

<style lang="less">
.aboutpage6 {
  .aboutpage6List {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 800px;
    margin: 0 auto;
    .item {
      display: flex;
      align-items: center;
      margin-bottom: 40px;
      width: 50%;
      .itemRight {
        margin-left: 20px;
        .titel {
          font-size: 22px;
          font-weight: bold;
          color: rgba(22, 81, 148, 1);
          line-height: 48px;
        }
        .text {
          font-size: 18px;
          font-family: PingFang;
          font-weight: bold;
          color: rgba(52, 52, 52, 1);
          line-height: 48px;
        }
      }
    }
  }
  .about-box {
    margin: 30px auto 0;
    width: 800px;
    height: 350px;
    text-align: center;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 10px 30px 0px rgba(146, 146, 146, 0.17);
    overflow: hidden;
  }
  .consulting-title {
    font-size: 50px;
    font-family: PingFang;
    font-weight: 400;
    color: rgba(52, 52, 52, 1);
    text-align: center;
  }
  .consulting-line {
    margin: 20px auto;
    width: 90px;
    height: 3px;
    background: rgba(108, 44, 102, 1);
  }
  .consulting-area {
    margin-top: 50px;
    display: flex;
    justify-content: space-between;
    .areaImg {
      width: 700px;
      height: 473px;
      overflow: hidden;
      img {
        height: 100%;
      }
    }
    .areaBox {
      width: calc(100% - 700px);
      height: 473px;
      img {
        height: 100%;
      }
      // // padding: 40px;
      // background: rgba(22, 81, 148, 1);
      // box-sizing: border-box;
      // color: rgba(255, 255, 255, 1);
      // .p1 {
      //   margin: 14px 0 0;
      //   font-size: 16px;
      // }
      // .h1 {
      //   margin: 14px 0 40px;
      //   font-size: 24px;
      // }
      // .p2 {
      //   display: flex;
      //   // align-items: center;
      //   margin: 10px 0;
      //   font-size: 18px;
      //   line-height: 20px;
      // }
    }
  }
  .box-title {
    margin: 40px 0 20px;
    font-size: 36px;
    font-family: PingFang;
    font-weight: bold;
    color: rgba(52, 52, 52, 1);
    line-height: 48px;
    letter-spacing: 6px;
  }
  .box-img .el-image {
    width: 180px;
  }
  .box-footer {
    font-size: 16px;
    font-weight: bold;
    color: rgba(52, 52, 52, 1);
  }
}
</style>
